import { useEffect } from 'react';
import { useRouter } from 'next/router';
import orderBy from 'lodash/orderBy';
import { ClipLoader } from 'react-spinners';
import { useMutation, useQuery } from 'react-query';
import { ConversationWithLastMessage } from 'api/conversation/types';
import { ConversationSidebar } from 'components/ConversationSidebar';

import { postConversation } from 'api/conversation';
import { getStorageItem } from 'utils/storage';
import { reactQuery } from 'lib/reactQuery';
import { fetchBot, fetchBots } from 'api/bot';
import { GetServerSideProps } from 'next';
import { useUserAgent } from 'next-useragent';

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const userAgent = req.headers['user-agent'] || '';
  return { props: { userAgent } };
};

type Props = { userAgent: string };

const ChatPage = ({ userAgent }: Props) => {
  const { push } = useRouter();
  const { isMobile } = useUserAgent(userAgent);

  const { mutate } = useMutation(postConversation);
  const { data } = useQuery('bots', () => fetchBots({ mine: false }));
  const { mutate: getBot } = useMutation(fetchBot);

  const conversations: ConversationWithLastMessage[] = reactQuery.getQueryData(['all-conversations']) || [];
  const status = reactQuery.getQueryState(['all-conversations'])?.status;

  useEffect(() => {
    const bots = data?.data;

    if (!bots?.length || isMobile) return;

    const isLogged = getStorageItem('user');
    let botName;
    let botId;

    if (isLogged && !conversations.length && status === 'success') {
      const bot = bots[0];
      mutate(bot.id, { onSuccess: () => push(`/chat/${bot.id}/${bot.bot_name}`) });
      return;
    }

    if (isLogged) {
      if (!conversations.length) return;
      const sorted = orderBy(
        conversations,
        (e) => (e.last_message?.created_at ? new Date(e.last_message.created_at).getTime() : 0),
        ['desc']
      );

      getBot(sorted[0].account_id, {
        onSuccess: (data) => push(`/chat/${data.id}/${data.bot_name}`),
        onError: () => push(`/chat/${bots[0].id}/${bots[0].bot_name}`)
      });
    } else {
      botName = bots[0].bot_name;
      botId = bots[0].id;

      push(`/chat/${botId}/${botName}`);
    }

    // eslint-disable-next-line
  }, [data, conversations, status]);

  return (
    <>
      {isMobile ? (
        <div className="h-full overflow-hidden relative flex">
          <ConversationSidebar bot={data?.data?.[0]} />
        </div>
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <ClipLoader color="#fff" size={24} />
        </div>
      )}
    </>
  );
};

export default ChatPage;
